module.exports = __webpack_public_path__ + "static/img/home_entrance_exchange_1.640bf4f1.png";